import { render, staticRenderFns } from "./RewardEmptyState.vue?vue&type=template&id=0e537442"
import script from "./RewardEmptyState.vue?vue&type=script&lang=js"
export * from "./RewardEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports